var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorCircleActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.875,
    height: 17.875,
    viewBox: "0 0 17.875 17.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "error_circle_active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:red;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.438,9.5A8.938,8.938,0,1,1,9.5.563,8.937,8.937,0,0,1,18.438,9.5ZM9.5,11.3a1.658,1.658,0,1,0,1.658,1.658A1.658,1.658,0,0,0,9.5,11.3ZM7.926,5.343l.267,4.9a.432.432,0,0,0,.432.409h1.75a.432.432,0,0,0,.432-.409l.267-4.9a.432.432,0,0,0-.432-.456H8.358A.432.432,0,0,0,7.926,5.343Z",
    transform: "translate(-0.563 -0.563)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircleActive);
export default __webpack_public_path__ + "static/media/error_circle_active.f8098494868850b9d86d8f49cb102b35.svg";
export { ForwardRef as ReactComponent };